<div class="min-h-screen bg-slate-900">
  <!-- Mobile Sidenav Overlay -->
  @if (sidenavOpen) {
    <div
      class="fixed inset-0 bg-black/60 z-40 lg:hidden transition-opacity backdrop-blur-sm"
      (click)="closeSidenav()">
    </div>
  }

  <!-- Mobile Sidenav -->
  <aside
    class="fixed top-0 left-0 z-50 h-full w-72 bg-slate-900/95 backdrop-blur-xl border-r border-white/5 transform transition-transform duration-300 ease-in-out lg:hidden"
    [class.translate-x-0]="sidenavOpen"
    [class.-translate-x-full]="!sidenavOpen">
    <div class="flex items-center justify-between p-4 border-b border-white/5">
      <span class="text-white font-semibold text-lg">Menu</span>
      <button
        (click)="closeSidenav()"
        class="p-2 text-slate-400 hover:text-white transition-colors rounded-lg hover:bg-white/5">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
    <app-sidenav-tree (itemClicked)="closeSidenav()"></app-sidenav-tree>
  </aside>

  <!-- Header -->
  <app-header (menuToggle)="toggleSidenav()"></app-header>

  <!-- Loading Bar -->
  @if (isLoading) {
    <div class="fixed top-0 left-0 right-0 z-50 h-1 bg-primary-900/50">
      <div class="h-full bg-primary-500 animate-pulse" style="width: 60%"></div>
    </div>
  }

  <!-- Main Content -->
  <main>
    <router-outlet></router-outlet>
  </main>
</div>
